/**
 * Owner Routes
 *
 * Route definitions for the owners module.
 */

import { lazy } from 'react';

const OwnerManagement = lazy(() => import('@/pages/owners/OwnerManagement'));
const OwnerDetailLayout = lazy(() => import('@/pages/owners/OwnerDetailLayout'));
const OwnerOverviewPage = lazy(() => import('@/pages/owners/OwnerOverviewPage'));
const OwnerInvestorSharesPage = lazy(() => import('@/pages/owners/OwnerInvestorSharesPage'));
const OwnerAccountingPage = lazy(() => import('@/pages/owners/OwnerAccountingPage'));
const OwnerNotesPage = lazy(() => import('@/pages/owners/OwnerNotesPage'));
const OwnerDocumentsPage = lazy(() => import('@/pages/owners/OwnerDocumentsPage'));
const OwnerWegStatementPage = lazy(() => import('@/pages/owners/OwnerWegStatementPage'));
const OwnerSevStatementPage = lazy(() => import('@/pages/owners/OwnerSevStatementPage'));

export const ownerRoutes = [
    {
        path: 'owners',
        element: <OwnerManagement />,
    },
    {
        path: 'owners/:id',
        element: <OwnerDetailLayout />,
        children: [
            { index: true, element: <OwnerOverviewPage /> },
            { path: 'overview', element: <OwnerOverviewPage /> },
            { path: 'investor-shares', element: <OwnerInvestorSharesPage /> },
            { path: 'accounting', element: <OwnerAccountingPage /> },
            { path: 'notes', element: <OwnerNotesPage /> },
            { path: 'documents', element: <OwnerDocumentsPage /> },
            { path: 'weg-statement', element: <OwnerWegStatementPage /> },
            { path: 'sev-statement', element: <OwnerSevStatementPage /> },
        ],
    },
];
